import Markdown from 'react-markdown'
import { useSelector } from 'react-redux'

import {
  answerSelector,
  currentNumberSelector,
  lengthSelector,
} from '@/services/slices/questionSlice'
import QuestionCounter from '@/ui/QuestionCounter/QuestionCounter'
import classNames from 'classnames'
import rehypeRaw from 'rehype-raw'

import styles from './AnswerCard.module.scss'

import AnswerCheck from '../AnswerCheck/AnswerCheck'

const AnswerCard = () => {
  const number = useSelector(currentNumberSelector)
  const length = useSelector(lengthSelector)
  const { right, text, name } = useSelector(answerSelector)

  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <h1
          className={classNames(
            'text',
            't-caption',
            'text_color_tertiary',
            styles.heading,
          )}
        >
          Вопрос {number} из {length}
        </h1>

        <div className={styles.answer_wrapper}>
          <p
            className={classNames(
              'text',
              't-caption-big',
              'text_color_primary',
              styles.text,
            )}
          >
            Ваш ответ: {name}
          </p>

          <AnswerCheck right={right} />
        </div>

        <Markdown
          components={{
            a: ({ href, children }) => (
              <a href={href} target="_blank">
                {children}
              </a>
            ),
          }}
          rehypePlugins={[rehypeRaw]}
          className={classNames(
            'text',
            't-body',
            'text_color_primary',
            styles.texts,
          )}
        >
          {text}
        </Markdown>
      </div>

      <QuestionCounter />
    </div>
  )
}

export default AnswerCard
